"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordsEqual = void 0;
require("../../../core");
const passwordsEqual = (passwordNotEqualText) => {
    return (value, values) => {
        const isEqual = values.password === values.repeatPassword;
        return isEqual ? '' : passwordNotEqualText;
    };
};
exports.passwordsEqual = passwordsEqual;
//# sourceMappingURL=passwordsEqual.js.map